/*eslint-disable*/
import React from "react";

// reactstrap components

// core components

function PresentationHeader() {
  return (
    <>
      <div className="page-header clear-filter">
        <div className="rellax-header rellax-header-sky" data-rellax-speed="-4">
          <div
            className="page-header-image"
            style={{
              backgroundImage:
                "url(" +
                require("assets/img/presentation-page/nuk-pro-back-sky.jpg") +
                ")"
            }}
          ></div>
        </div>
        <div
          className="rellax-header rellax-header-buildings"
          data-rellax-speed="0"
        >
          <div
            className="page-header-image page-header-city"
            style={{
              backgroundImage:
                "url(" +
                require("assets/img/presentation-page/nuk-pro-buildings.png") +
                ")"
            }}
          ></div>
        </div>
        <div className="rellax-text-container rellax-text">
          <h1 className="h1-seo" data-rellax-speed="-1">
            Site Intel Hub
          </h1>
          <div className="pro">PRO</div>
        </div>
        <h3 className="h3-description rellax-text" data-rellax-speed="-1">
          Transforming Real Estate Decisions through Data-Driven Insights
          and Unmatched Tools - Discover Site Intel Hub, Where Every Property
          Choice Is Informed and Empowered.
        </h3>
        <h6
          className="category category-absolute rellax-text"
          data-rellax-speed="-1"
        >
          Powered by
          {" "}
          <img
              alt="..."
              className="creative-tim-logo"
              src={require("assets/img/logo.png")}
              style={{width:'16px', height:'16px'}}
          ></img>
          {" "}
          Site Intel Hub.
        </h6>
      </div>
    </>
  );
}

export default PresentationHeader;
